<div class="row" *ngIf="widgetType && w && w.timeSeriesList">
    <div class="col-lg-3">
      <div class="form-group">
        <h3>Name</h3>
        <input type="text" placeholder="widget name" max="15" class="form-control" [(ngModel)]="w.name">
      </div>
    </div>
    <div class="col-lg-3">
      <div class="form-group">
        <h3>Units</h3>
        <input type="text" placeholder="unit type" max="5" class="form-control" [(ngModel)]="w.units">
      </div>
    </div>
    <div class="col-lg-5">
      <div class="form-group">
        <h3>Valid Period</h3>        
        <app-time-period [(period)]="w.period" [type]="'text'"></app-time-period>
      </div>
    </div>
    <div class="col-lg-3">
      <div class="form-group">
        <h3>Display Value</h3>        
        <select [(ngModel)]="w.display" class="form-select">
          <option>Latest</option>
          <option>Average</option>
          <option>Maximum</option>
          <option>Minimum</option>
          <option>Change</option>
          <option>Total</option>
        </select>
      </div>
    </div>


    <div class="col-lg-3">
      <div class="form-group input-group-sm">
        <h3>Refresh (Seconds)</h3>
        <input
          min="60"
          type="text"
          placeholder="refresh interval"
          class="form-control"
          [(ngModel)]="w.refreshInterval"
        />
      </div>
    </div>
    <div class="col-lg-3">
      <div class="form-group">
        <h3>Background Opacity</h3>        
        <select [(ngModel)]="w.opacity" class="form-select">
          <option>30</option>
          <option>40</option>
          <option>50</option>
          <option>60</option>
          <option>70</option>
          <option>80</option>
          <option>90</option>
          <option>100</option>
        </select>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="widgetType && w && w.timeSeriesList">
    <div class="col-lg-5">
      <div class="form-group input-group-sm">
        <label>Select Time Series </label>
        <app-uri-select [customerId]="dashboard.customerId" [timeSeriesDetail]="w.timeSeriesList[0]" [enableMediaSearch]="false" [enableTagMatch]="true" [siteTypeCode]="dashboard.siteType" [siteUri]="siteUri"></app-uri-select>
        <!--<app-time-series-select [timeSeriesDetail]="w.timeSeriesList[0]" [enableTagMatch]="true"></app-time-series-select>-->
      </div>
      <div class="form-group">
        <app-transform-editor [transforms]="w.timeSeriesList[0].transforms"></app-transform-editor>
      </div>
    </div>
    <div class="col-lg-7">
      <div class="row" *ngIf="widgetType">
        <div class="col-lg-6">
          <div class="panel bg-opacity-30">
            <div class="panel-body">
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label class="control-label">Min / Max</label>
                    <div class="input-group bg-default bg-opacity-30">
                      <input type="text" placeholder="min" class="form-control" [(ngModel)]="w.default.min">
                      <input type="text" placeholder="max" class="form-control" [(ngModel)]="w.default.max">
                    </div>
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="form-group">
                    <label class="control-label">Icon</label>   
                    <div class="input-group">
                      <select [(ngModel)]="w.default.icon" class="form-select bg-default bg-opacity-30">
                        <option *ngFor="let i of icons" [value]="i">{{i}}</option>
                      </select>
                      <div class="input-group-text"><i [ngClass]="w.default.icon"></i></div>
                    </div>             
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="panel bg-opacity-30">
            <div class="panel-body">
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label class="control-label">Min / Max</label>
                    <div class="input-group bg-primary bg-opacity-30">
                      <input type="text" placeholder="min" class="form-control" [(ngModel)]="w.primary.min">
                      <input type="text" placeholder="max" class="form-control" [(ngModel)]="w.primary.max">
                    </div>
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="form-group">
                    <label class="control-label">Icon</label>      
                    <div class="input-group">
                      <select [(ngModel)]="w.primary.icon" class="form-select bg-primary bg-opacity-30">
                        <option *ngFor="let i of icons" [value]="i">{{i}}</option>
                      </select>
                      <div class="input-group-text"><i [ngClass]="w.primary.icon"></i></div>
                    </div>          
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="panel bg-opacity-30">
            <div class="panel-body">
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label class="control-label">Min / Max</label>
                    <div class="input-group bg-success bg-opacity-30">
                      <input type="text" placeholder="min" class="form-control" [(ngModel)]="w.success.min">
                      <input type="text" placeholder="max" class="form-control" [(ngModel)]="w.success.max">
                    </div>
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="form-group">
                    <label class="control-label">Icon</label>
                    <div class="input-group">
                      <select [(ngModel)]="w.success.icon" class="form-select bg-success bg-opacity-30">
                        <option *ngFor="let i of icons" [value]="i">{{i}}</option>
                      </select>
                      <div class="input-group-text"><i [ngClass]="w.success.icon"></i></div>
                    </div>            
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>    
        <div class="col-lg-6">
          <div class="panel bg-opacity-30">
            <div class="panel-body">
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label class="control-label">Min / Max</label>
                    <div class="input-group bg-info bg-opacity-30">
                      <input type="text" placeholder="min" class="form-control" [(ngModel)]="w.info.min">
                      <input type="text" placeholder="max" class="form-control" [(ngModel)]="w.info.max">
                    </div>
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="form-group">
                    <label class="control-label">Icon</label>                
                    <div class="input-group">
                      <select [(ngModel)]="w.info.icon" class="form-select bg-info bg-opacity-30">
                        <option *ngFor="let i of icons" [value]="i">{{i}}</option>
                      </select>
                      <div class="input-group-text"><i [ngClass]="w.info.icon"></i></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>    
        <div class="col-lg-6">
          <div class="panel bg-opacity-30">
            <div class="panel-body">
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label class="control-label">Min / Max</label>
                    <div class="input-group bg-warning bg-opacity-30">
                      <input type="text" placeholder="min" class="form-control" [(ngModel)]="w.warning.min">
                      <input type="text" placeholder="max" class="form-control" [(ngModel)]="w.warning.max">
                    </div>
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="form-group">
                    <label class="control-label">Icon</label>
                    <div class="input-group">  
                      <select [(ngModel)]="w.warning.icon" class="form-select bg-warning bg-opacity-30">
                        <option *ngFor="let i of icons" [value]="i">{{i}}</option>
                      </select>
                      <div class="input-group-text"><i [ngClass]="w.warning.icon"></i></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="panel bg-opacity-30">
            <div class="panel-body">
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label class="control-label">Min / Max</label>
                    <div class="input-group bg-danger bg-opacity-30">
                      <input type="text" placeholder="min" class="form-control" [(ngModel)]="w.danger.min">
                      <input type="text" placeholder="max" class="form-control" [(ngModel)]="w.danger.max">
                    </div>
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="form-group">
                    <label class="control-label">Icon</label>                
                    <div class="input-group">
                      <select [(ngModel)]="w.danger.icon" class="form-select bg-danger bg-opacity-30 ">
                        <option *ngFor="let i of icons" [value]="i">{{i}}</option>
                      </select>
                      <div class="input-group-text"><i [ngClass]="w.danger.icon"></i></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  
